import { returnData, apiClientVersioned } from '../index'

import type { IAuthUser, IUserSettings } from '../types/authUser'

export const AuthApi = {
  me: () => returnData(apiClientVersioned.get<IAuthUser>(`/users/me`)),
  updateMe: (payload: Pick<IAuthUser, 'email' | 'settings'>) =>
    returnData(apiClientVersioned.patch<IAuthUser>(`/users/me`, payload)),

  // @deprecated
  updateUserSettings: (userSettings: IUserSettings) =>
    returnData(
      apiClientVersioned.post<IUserSettings>(
        `/users/user/settings/update`,
        userSettings,
      ),
    ),
}
